// extracted by mini-css-extract-plugin
export default {"container":"styles_container__qR4XD","moreVertical":"styles_moreVertical__Us287","messageContainer":"styles_messageContainer__MY8hD"};